import AiTermsAndConditions from './aiTermsAndConditions';

export default AiTermsAndConditions;
